/* ==========================================================================
   LV- Collection Grid — Laverne Diamonds
   assets/lv-collection-grid.js

   Custom element so the Shopify editor lifecycle is native. The grid is pure
   CSS; the only job here is the staggered reveal. The hidden state is applied
   by JS (anim-ready) so a visitor with a blocked script never sees an
   invisible section.
   ========================================================================== */
(() => {
  'use strict';

  if (customElements.get('lv-collection-grid')) return;

  const REDUCED = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  class LVCollectionGrid extends HTMLElement {
    connectedCallback() {
      this.root = this.querySelector('[data-cg]');
      if (!this.root) return;
      this.reveal();
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }

    reveal() {
      const items = this.root.querySelectorAll('[data-animate]');
      if (!items.length) return;

      if (!('IntersectionObserver' in window) || REDUCED()) {
        this.root.classList.add('is-in');
        return;
      }
      this.root.classList.add('anim-ready');

      // Already in view on load, or dropped in by the theme editor: reveal on
      // the next frame rather than waiting for a scroll that never comes.
      if (this.root.getBoundingClientRect().top < innerHeight * 0.9) {
        requestAnimationFrame(() => this.root.classList.add('is-in'));
        return;
      }

      this._io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          this.root.classList.add('is-in');
          this._io.disconnect();
        });
      }, { threshold: 0.1 });
      this._io.observe(this.root);
    }
  }

  customElements.define('lv-collection-grid', LVCollectionGrid);
})();
